import { htmlSafe } from "@/brains/flang";
import { zz } from "@/brains/malf";

export function kbScrollToParam(kitInstanceId: number, elementPath: string) {
  scrollToId("kit-builder", htmlSafe(`kb-${kitInstanceId}.${elementPath}`));
}
export function kbScrollToLegoInstance(kitInstanceId: number) {
  scrollToId("kit-builder", htmlSafe(`kb-li-${kitInstanceId}`), 120);
}
export function kbScrollToOutput(kitInstanceId: number) {
  console.log("scroll to kb");
  scrollToId("kit-builder", htmlSafe(`kb-output-${kitInstanceId}`), 120);
}
export function legoHqScrollToDir(directoryId: number) {
  scrollToId("legos-hq", htmlSafe(`legos-hq-dir-${directoryId}`), 120);
}
export function scrollToId(
  parentId: string,
  targetId: string,
  pushDownPage = 0.35
) {
  if (!parentId.startsWith("#")) parentId = "#" + parentId;
  if (!targetId.startsWith("#")) targetId = "#" + targetId;
  const target = document.querySelector(targetId);
  const parent = document.querySelector(parentId);
  if (!parent) {
    zz(`${parentId} not found in DOM while trying to scroll!`);
    return;
  }
  if (!target) {
    zz(`${targetId} not found in DOM while trying to scroll!`);
    return;
  }
  const viewportToParent = parent.getBoundingClientRect().y;
  const viewportToTarget = target.getBoundingClientRect().y;
  const parentCurrentScroll = parent.scrollTop;
  const parentToTarget =
    viewportToTarget - viewportToParent + parentCurrentScroll;
  if (pushDownPage < 1 && pushDownPage > 0) {
    pushDownPage = window.innerHeight * pushDownPage;
  }
  zz({ viewportToTarget });
  zz({ viewportToParent });
  zz({ parentCurrentScroll });
  zz({ parentToTarget });
  zz({ pushDownPage });
  zz({
    targetRect: document.querySelector(targetId)?.getBoundingClientRect(),
  });
  zz({ parentRect: parent.getBoundingClientRect() });

  parent.scrollTo({
    left: 0,
    top: parentToTarget - pushDownPage,
    behavior: "smooth",
  });
}
